/**
 * Utility class with no dependencies. Used in components that are stripped in separate bundles
 * and requires as less dependencies as possible.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getURLWithoutParams } from '../base/connection/utils';
import { doGetJSON } from '../base/util/httpUtils';
// @ts-ignore
import { meetingService } from '../../../service';
let confMapperURL = '';
/**
 * Formats the conference pin in readable way for UI to display it.
 * Formats the pin in 3 groups of digits:
 * XXXX XXXX XX or XXXXX XXXXX XXX.
 * The length of first and second group is Math.ceil(pin.length / 3).
 *
 * @param {Object} conferenceID - The conference id to format, string or number.
 * @returns {string} - The formatted conference pin.
 * @private
 */
export function _formatConferenceIDPin(conferenceID) {
    const conferenceIDStr = conferenceID.toString();
    // let's split the conferenceID in 3 parts, to be easier to read
    const partLen = Math.ceil(conferenceIDStr.length / 3);
    return `${conferenceIDStr.substring(0, partLen)} ${conferenceIDStr.substring(partLen, 2 * partLen)} ${conferenceIDStr.substring(2 * partLen, conferenceIDStr.length)}`;
}
/**
 * Sends a GET request to obtain the conference ID necessary for identifying
 * which conference to join after dialing the dial-in service.
 * This function is used not only in the main app bundle but in separate bundles for the dial in numbers page,
 * and we do want to limit the dependencies.
 *
 * @param {string} baseUrl - The url for obtaining the conference ID (pin) for
 * dialing into a conference.
 * @param {string} roomName - The conference name to find the associated
 * conference ID.
 * @param {string} mucURL - In which MUC the conference exists.
 * @param {URL} url - The address we are loaded in.
 * @returns {Promise} - The promise created by the request.
 */
export function getDialInConferenceID(baseUrl, roomName, mucURL, url) {
    return __awaiter(this, void 0, void 0, function* () {
        confMapperURL = baseUrl;
        const separator = baseUrl.includes('?') ? '&' : '?';
        const accountName = yield getAccountName(roomName);
        const conferenceIDURL = `${baseUrl}${separator}account=${accountName}&conference=${roomName}@${mucURL}&url=${getURLWithoutParams(url).href}`;
        /*     console.log('xxx getDialInConferenceID: ', baseUrl)
            console.log('xxx getDialInConferenceID: ', roomName)
            console.log('xxx getDialInConferenceID: ', url)
            console.log('xxx getDialInConferenceID: ', mucURL)
            console.log('xxx getDialInConferenceID: ', conferenceIDURL) */
        return doGetJSON(conferenceIDURL, true);
    });
}
/**
 * Sends a GET request for phone numbers used to dial into a conference.
 * This function is used not only in the main app bundle but in separate bundles for the dial in numbers page,
 * and we do want to limit the dependencies.
 *
 * @param {string} url - The service that returns conference dial-in numbers.
 * @param {string} roomName - The conference name to find the associated
 * conference ID.
 * @param {string} mucURL - In which MUC the conference exists.
 * @returns {Promise} - The promise created by the request. The returned numbers
 * may be an array of Objects containing numbers, with keys countryCode,
 * tollFree, formattedNumber or an object with countries as keys and arrays of
 * phone number strings, as the second one should not be used and is deprecated.
 */
export function getDialInNumbers(url, roomName, mucURL) {
    return __awaiter(this, void 0, void 0, function* () {
        const separator = url.includes('?') ? '&' : '?';
        const accountName = yield getAccountName(roomName);
        // when roomName and mucURL are available
        // provide conference when looking up dial in numbers
        /*     console.log('xxx getDialInNumbers: ', roomName);
            console.log('xxx getDialInNumbers: ', url);
            console.log('xxx getDialInNumbers: ', mucURL);
            console.log('xxx getDialInNumbers: ', url + (roomName && mucURL ? `${separator}account=${accountName}&conference=${roomName}@${mucURL}` : '')); */
        return doGetJSON(url + (roomName && mucURL ? `${separator}account=${accountName}&conference=${roomName}@${mucURL}` : ''), true);
    });
}
export function getAccountName(roomName) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield meetingService.getMeeting(roomName);
        return result.data.workspaceId;
    });
}
